import { FC, useEffect, useState } from 'react';
import { CompanyFormProps, FormValues } from './interfaces/ICompanyForm';
import { EmailController, SelectController, TextController } from '../utils/controllers';
import { BaseForm } from '../utils/BaseForm';
import { useHUser } from '../items/hooks/HUsers';

const CompanyForm: FC<CompanyFormProps> = ({
    open,
    onClose,
    onSubmit,
    title = 'Add Company',
    submitText = 'Add Company',
    initialValues,
}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { roles, loading: rolesLoading, fetchRoles } = useHUser();

    useEffect(() => {
        fetchRoles();
    }, [fetchRoles]);

    const defaultValues: FormValues = {
        name: '',
        email: '',
        phoneNumber: '',
        country: '',
        role: '',
        ...initialValues,
    };

    const transformData = (data: FormValues) => ({
        id: data.id,
        name: data.name.trim(),
        email: data.email.trim(),
        phoneNumber: data.phoneNumber.trim(),
        country: data.country.trim(),
        role: data.role.trim(),
    });

    const handleSubmit = async (transformedData: FormValues) => {
        setIsSubmitting(true);
        try {
            await onSubmit(transformedData);
        } catch (error) {
            throw error;
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <BaseForm
            open={open}
            onClose={onClose}
            onSubmit={handleSubmit}
            title={title}
            defaultValues={defaultValues}
            transformData={transformData}
            loading={isSubmitting}
            submitText={submitText}
        >
            {(control) => (
                <>
                    <TextController
                        name='name'
                        control={control}
                        label='Company Name'
                        rules={{ required: 'Company name is required' }}
                        sx={{ marginBottom: 2 }}
                    />
                    <EmailController
                        name='email'
                        control={control}
                        label='Email'
                        rules={{ required: 'Email is required' }}
                        sx={{ marginBottom: 2 }}
                    />
                    <TextController
                        name='phoneNumber'
                        control={control}
                        label='Phone Number'
                        sx={{ marginBottom: 2 }}
                    />
                    <TextController
                        name='country'
                        control={control}
                        label='Country'
                        rules={{ required: 'Country is required' }}
                        sx={{ marginBottom: 2 }}
                    />
                    <SelectController
                        name='role'
                        control={control}
                        label='Role'
                        options={roles.map((role) => ({ value: role.role, label: role.role }))}
                        rules={{ required: 'Role is required' }}
                        disabled={rolesLoading}
                    />
                </>
            )}
        </BaseForm>
    );
};

export default CompanyForm;